import React from 'react';
import { Typography } from '@mui/material';

type MessageProps = {
  message: any;
};

const formatText = (text: any): string => {
  if (typeof text !== 'string') return '';
  
  return text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/\*(.*?)\*/g, '<b>$1</b>')        
    .replace(/_(.*?)_/g, '<i>$1</i>')        
    .replace(/~(.*?)~/g, '<s>$1</s>')       
    .replace(/```(.*?)```/g, '<code>$1</code>') 
    .replace(/(https?:\/\/[^\s]+)/g, '<a href="$1" target="_blank" rel="noopener noreferrer">$1</a>') // link
    .replace(/\n/g, '<br />');                 
};


const MessageTypeButtonReply: React.FC<MessageProps> = ({ message }) => {
  try {
    const convertOrShow = (variable: any): string => {
      if (variable) {
        if (typeof variable === 'object') {
          return JSON.stringify(variable);
        }
        return variable.toString();
      }
      return 'Button reply not found';
    };

    const messageContent =
      message?.content?.button_reply || message?.content?.text || 'Button reply not found';

    const formattedText = formatText(convertOrShow(messageContent));


    return (
      <Typography variant="body1" sx={{ whiteSpace: 'pre-wrap' }} dangerouslySetInnerHTML={{ __html: formattedText }}>
        {/* {convertOrShow(messageContent)} */}
      </Typography>
    );
  } catch (error) {
    return <div>Button reply not found</div>;
  }
};

export default MessageTypeButtonReply;
